export const REDCAT_ICON_DEFAULT_SIZE = 24;
export const REDCAT_ICON_DEFAULT_COLOR = '#000000';

export interface RedcatIconProps {
  size?: number;
  color?: string;
}
